export default "__VITE_ASSET__449154cc__"